module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "addBusinessClass",
      "title": "新增企业",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules,
      "label-position": "right"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地区",
      "prop": "showname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addForm.showname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "showname", $$v)
      },
      expression: "addForm.showname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号",
      "prop": "regionCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionCode", $$v)
      },
      expression: "addForm.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "grade", $$v)
      },
      expression: "addForm.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.natrue),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "natrue", $$v)
      },
      expression: "addForm.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userScale),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userScale", $$v)
      },
      expression: "addForm.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址",
      "prop": "addressInfo"
    }
  }, [_c('GisCommon', {
    attrs: {
      "selected": _vm.selected,
      "address": _vm.addForm.addressInfo,
      "lonLat": _vm.addForm.longitudeAndLatitude
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.addForm, "addressInfo", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.addForm.addressInfo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addressInfo", $$v)
      },
      expression: "addForm.addressInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级",
      "prop": "level"
    }
  }, [_c('el-rate', {
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.addForm.level),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "level", $$v)
      },
      expression: "addForm.level"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人",
      "prop": "linker"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linker),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linker", $$v)
      },
      expression: "addForm.linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linkerPhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linkerPhone", $$v)
      },
      expression: "addForm.linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业图标"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1c7338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/targetCustomDialog.vue
// module id = 1774
// module chunks = 9